import request from '@/utils/request'
export function CoogetList(data) {
    return request({
        url: `/home/partner/recom/list`,
        method: "get",
        params: data
    });
}
//showcases
export function showcasesgetList(data) {
    return request({
        url: `/home/example/recom/list`,
        method: "get",
        params: data
    });
}
//events
export function eventsgetList(data) {
    return request({
        url: `/home/activity/recom/list`,
        method: "get",
        params: data
    });
}
// news&info
export function infogetList(data) {
    return request({
        url: `/home/news/recom/list`,
        method: "get",
        params: data
    });
}